import { useState } from 'react'
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { Link } from 'react-router-dom'
import { Input } from '../../components/input'
import { InputWrapper } from '../../components/input/input.style'
import { AuthFormWrapper } from '../../container/authFormwarapper'
import { Heading, FormContainer, ButtonContainer } from '../../styles/auth'
import { Button } from '../../components/button'
import { Checkbox } from '../../components/checkbox'

//Registration schema
const schema = yup.object().shape({
    firstName: yup.string().required("First name is a required field"),
    lastName: yup.string().required("Last name is a required field "),
    password: yup.string().required("Password is a required field"),
    confirmPassword: yup.string()
        .required('Confirm Password is a required field')
        .oneOf([yup.ref('password')], 'Passwords must match'),
    acceptTerms: yup.bool()
        .oneOf([true], 'Accept Ts & Cs is required')
    // email: yup.string().email().required("email field is a required field"),

});


const Register = () => {
    const [isLoading, setIsLoading] = useState(false);
    const {
        handleSubmit,
        register,
        formState: { errors },
        watch,
    } = useForm({ resolver: yupResolver(schema), mode: "onChange" });
    // const formData = JSON.stringify(watch());

    const onSubmit = values => {
        console.log(values)
    }
    return (
        <AuthFormWrapper>
            <FormContainer>
                <Link to="/">Go home</Link>
                <Heading>Create account</Heading>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <InputWrapper>
                        <Input
                            id="firstname"
                            label="First Name"
                            type="text"
                            placeholder="First Name"
                            fullWidth
                            {...register("firstName")}
                            error={errors.firstName?.message}
                        />
                    </InputWrapper>
                    <InputWrapper>
                        <Input
                            id="lastname"
                            label="Last Name"
                            type="text"
                            placeholder="Last Name"
                            fullWidth
                            {...register("lastName")}
                            error={errors.lastName?.message}
                        />
                    </InputWrapper>
                    <InputWrapper>
                        <Input
                            endAdornment
                            id="password"
                            label="password"
                            type="password"
                            placeholder="Password"
                            fullWidth
                            {...register("password")}
                            error={errors.password?.message}
                        />
                    </InputWrapper>
                    <InputWrapper>
                        <Input
                            endAdornment
                            id="confirmPassword"
                            label="confirm password"
                            type="password"
                            placeholder="Password"
                            fullWidth
                            {...register("confirmPassword")}
                            error={errors.confirmPassword?.message}
                        />
                    </InputWrapper>
                    <InputWrapper>
                        <Checkbox
                            id="termsandconditions"
                            label="Agree to Terms and Conditions"
                            type="checkbox"
                            fullWidth
                            {...register("acceptTerms")}
                            error={errors.acceptTerms?.message}
                        />
                    </InputWrapper>
                    <ButtonContainer>
                        <Button
                            type="submit"
                            disabled={
                                Object.keys(errors).length > 0 ||
                                Object.values(watch()).length < 1 ||
                                isLoading
                            }
                            variant="primary"
                            isLoading={isLoading}
                            responsive
                        >
                            create account
                        </Button>
                        <Link to='/login'>
                            <Button
                                style={{ marginLeft: '20px' }}
                                variant="secondary"
                                isLoading={isLoading}
                                responsive
                            >
                                Log in

                            </Button>
                        </Link>
                    </ButtonContainer>

                </form>
            </FormContainer>
        </AuthFormWrapper>
    )
}

export default Register
